<template>
    <f7-app :params="f7params">
        <f7-panel left cover>
            <f7-view links-view=".view-main">
                <f7-page>
                    <f7-navbar title="JKAnimeAPP"></f7-navbar>

                    <div class="circular" style="width:100%;background-size: cover"
                         v-bind:style="{ backgroundImage: 'url(' + image + ')' }">
                        <img :src="logo" height="60px" style="margin:0 auto;display:block;padding:15px;"/>
                    </div>

                    <f7-list accordion-list style="margin: 0">
                        <f7-list-item accordion-item title="Géneros">
                            <f7-icon slot="media" icon="material-icons">list</f7-icon>
                            <f7-accordion-content>
                                <f7-block>
                                    <f7-list>
                                        <f7-list-item panel-close v-for="(genero, index) in datosUsuario.Generos"
                                                      :link="'/animes/genero/'+ genero.Genero"
                                                      :key="index"
                                                      :badge="genero.Total"
                                                      :title="genero.Genero">
                                        </f7-list-item>
                                    </f7-list>
                                </f7-block>
                            </f7-accordion-content>
                        </f7-list-item>
                        <f7-list-item accordion-item title="Letras">
                            <f7-icon slot="media" icon="material-icons">font_download</f7-icon>
                            <f7-accordion-content>
                                <f7-block>
                                    <f7-list>
                                        <f7-list-item panel-close link="/animes/letra/0-9" title="0-9"></f7-list-item>
                                        <f7-list-item panel-close v-for="(letra, index) in letters"
                                                      :link="'/animes/letra/'+letra"
                                                      :key="index"
                                                      :title="letra">
                                        </f7-list-item>
                                    </f7-list>
                                </f7-block>
                            </f7-accordion-content>
                        </f7-list-item>
                    </f7-list>
                    <f7-list style="margin: 0">
                        <f7-list-item link="/home" title="Inicio" panel-close>
                            <f7-icon slot="media" icon="material-icons">home</f7-icon>
                        </f7-list-item>
                        <f7-list-item link="/favoritos" title="Favoritos" panel-close>
                            <f7-icon slot="media" icon="material-icons">favorite</f7-icon>
                        </f7-list-item>
                        <f7-list-item title="F.A.Q" panel-close>
                            <f7-icon slot="media" icon="material-icons">help</f7-icon>
                        </f7-list-item>
                    </f7-list>
                    <p style="line-break:auto; font-size:13px; text-align:center;">
                        <small>{{ key }}</small>
                    </p>
                </f7-page>
            </f7-view>
        </f7-panel>
        <f7-view url="/" :main="true" class="safe-areas view-main" :master-detail-breakpoint="800"></f7-view>
    </f7-app>
</template>
<script>
    import routes from '../js/routes';
    import image from "../img/fondo.png"
    import logo from "../img/ic_launcher.png"

    export default {
        data() {
            return {
                f7params: {
                    name: 'JKAnimeAPP iOS',
                    theme: 'ios',
                    routes: routes,
                    serviceWorker: {
                        path: '/service-worker.js',
                    },
                },
                key: uuid,
                image: image,
                logo: logo,
                datosUsuario: {},
                recientes: [],
                portada: [],
                top: [],
            }
        },
        methods: {
            cargarPortada() {
                let self = this;
                self.$f7.preloader.show();
                this.$f7.request.json('https://www.jkanimeapp.com/ios/api.php?action=portada', function (data) {
                    self.recientes = data.response.recientes;
                    self.portada = data.response.portada;
                    self.datosUsuario = data.user;
                    self.top = data.user.TopAnime;

                    self.$f7.preloader.hide();
                });
            },
        },
        computed: {
            letters() {
                let letters = [];
                for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
                    letters.push(String.fromCharCode([i]))
                }
                return letters
            }
        },
        mounted() {
            this.$f7ready((f7) => {
                this.cargarPortada();
            })
        },
    }
</script>
